export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_15-3e0111985b2518e611334ddb2f7f0d2b.jpg";